import { Home, Heart, Search, UtensilsCrossed, Calendar } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";
import { haptic } from "@/utils/haptics";

const navigationItems = [
  {
    name: "Hjem",
    href: "/",
    icon: Home,
    authRequired: false
  },
  {
    name: "Mat",
    href: "/matkort",
    icon: Heart,
    authRequired: true
  },
  {
    name: "Måltider",
    href: "/maltider",
    icon: UtensilsCrossed,
    authRequired: true
  },
  {
    name: "Søk",
    href: "/sok",
    icon: Search,
    authRequired: false
  },
  {
    name: "Logg",
    href: "/logg",
    icon: Calendar,
    authRequired: true
  }
];

export function BottomNavigation() {
  const location = useLocation();
  const { user } = useAuth();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-t">
      <div className="flex items-center justify-around py-2 px-2 max-w-md mx-auto">
        {navigationItems.map((item) => {
          const isActive = location.pathname === item.href;
          const isDisabled = item.authRequired && !user;
          
          return (
            <Link
              key={item.name}
              to={isDisabled ? "/auth" : item.href}
              onClick={() => haptic(isActive ? 'light' : 'medium')}
              className={cn(
                "flex flex-col items-center gap-1 p-2 rounded-lg transition-all duration-200 min-w-0 flex-1 relative",
                "hover:bg-muted/50 active:scale-95",
                isActive && "bg-primary/10 text-primary",
                isDisabled && "opacity-50"
              )}
              style={{ minHeight: "44px" }}
            >
              <item.icon 
                className={cn(
                  "h-5 w-5 transition-colors",
                  isActive && "text-primary"
                )} 
              />
              <span className={cn(
                "text-xs font-medium truncate",
                isActive && "text-primary"
              )}>
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}